import classNames from 'classnames';
import If from '../If/If';

type Props = {
	count?: number;
	icon: string;
	iconPos?: 'left' | 'right';
}

export function CountWithIcon(props: Props) {
	const { count, icon, iconPos="left" } = props;

	return (
		<If condition={count !== null}>
			<span
				className={classNames({
					'rc-count': count && count > 0,
					[`icon-${iconPos} icon-${icon}`]: count && count > 0,
				})}
				data-icon={icon}
			>
				<p>{count}</p>
			</span>
		</If>
	);
}